import React, { useEffect, useRef, useState } from 'react'
import { getEventInfo, getLiveInfo, getLiveSchedule } from './service'
import Loading from '../../Components/Loading/Loading'
import { useDispatch, useSelector } from 'react-redux'
import VideoJS from '../../Components/VideoJsPlayer/VideoJS'
import { getUserSubscription } from "../../network/service";
import { getVideoSubscription } from "../Subscription/service";
import { convertTimeToLocal, onVideoPlayFunction, translateText, fetchApiDataV2, imageUrlCheck } from '../../utils/utils'
import { getUserSubscriptionData } from "../../Redux/UserSubscriptionDetails/userSubscriptionSlice";
import { useLocation, useNavigate } from 'react-router-dom'
import { toast } from "react-toastify";
import Translate from '../../Components/Multilanguage/Translate'
import { useTranslation } from 'react-i18next';
import Comment from '../VideoPlayer/Components/Comment'
import LiveChat from './Components/LiveChat'
import ShowCard from '../../Components/ShowCard/ShowCard'
import { ReactComponent as PlayIcon } from '../../assets/Icons/godtvplay.svg'
let debounce = true;
var videoStarted = false;
let seconds = 60;
let prevTime;

const LivePlayer = () => {
  const { t } = useTranslation();
  const languageModal = useSelector((state) => state?.languageModal?.value);
  const [loading, setLoading] = useState(true)
  const projectInfo = useSelector((state) => state?.projectInfo?.value);
  const accessToken = useSelector((state) => state?.accessToken?.value);
  const sessionId = useSelector((state) => state?.sessionId?.value);
  const user = useSelector((state) => state?.user?.value);
  const location = useLocation()
  const [liveDetails, setLiveDetails] = useState()
  const [livePlayer, setLivePlayer] = useState()
  const [liveStarted, setLiveStarted] = useState(false)
  const [scheduleExpanded, setScheduleExpanded] = useState(false)
  const [isLivePlaying, setIsLivePlaying] = useState(false)
  const [liveInitialOverlay, setLiveInitialOverlay] = useState(false)
  const [featuredData, setFeaturedData] = useState(null)
  const [scheduleData, setScheduleData] = useState([])
  const dispatch = useDispatch();
  const navigate = useNavigate();

  const kids = projectInfo?.projectConfig?.config?.TEMPLATE === 'TEMPLATE_12';

  const appInfo = {
    projectDetails: projectInfo,
    accessToken: accessToken,
    sessionId: sessionId
  }
  const playerRef = useRef(null);
  const liveDetailsRef = useRef(liveDetails);
  const scheduleFetchedRef = useRef(false);

  useEffect(() => {
    liveDetailsRef.current = liveDetails;
  }, [liveDetails]);

  useEffect(() => {
    if (kids) setLiveInitialOverlay(true);
  }, [kids]);

  const eventId = location?.state?.eventId || localStorage.getItem("eventId")

  useEffect(() => {
    if (projectInfo?.projectConfig?.config?.LIVE_LOGIN_REQUIRED === "true" && !user) {
      if (projectInfo?.projectConfig?.config?.WEBSITE_NEW_CHECKOUT_REQUIRED === 'true') {
        navigate("/checkout", {
          state: {
            ...location.state,
            path: location?.pathname,
          }
        });
      } else {
        navigate("/login", {
          state: {
            ...location.state,
            path: location?.pathname,

          }
        });
      }
      return;
    }
  }, []);

  useEffect(() => {
    setLoading(true)

    if (eventId) {
      localStorage.removeItem("eventId")
      fetchEventInfo()
    } else {
      fetchLiveInfo()
    }
  }, [])

  useEffect(() => {
    if (kids) {
      fetchFeaturedData()
    }
  }, [kids])

  useEffect(() => {
    const startTime = new Date(liveDetails?.up_next?.start_time).getTime();
    const currentTime = new Date().getTime();

    // Calculate the time difference
    const timeUntilStart = startTime - currentTime;

    if (timeUntilStart > 0) {
      const timer = setTimeout(() => {
        // console.log('Up next has started!');

        if (eventId) {
          fetchEventInfo()
        } else {
          fetchLiveInfo()
        }
      }, timeUntilStart);

      return () => clearTimeout(timer);
    }

    if (timeUntilStart <= 0) {
      // console.log('Up next has already started!');
    }

    if (kids && !eventId && !scheduleFetchedRef.current) {
      scheduleFetchedRef.current = true;
      fetchScheduleData(liveDetails?.up_next?.start_time)
    }

  }, [liveDetails]);

  useEffect(() => {

    if (!liveStarted && liveDetails) {
      setLiveStarted(true);
      const hasLiveUrl = liveDetails && liveDetails.live_url;

      if (hasLiveUrl) {
        checkSubscriptionDetails()
      } else {
        toast.error(<Translate textKey={'wrong_try_again_msg'}/>)
      }

    }
  }, [liveDetails])

  const subscriptionCheck = async (userSubscription, channelSubscription) => {
    return userSubscription?.some((user) => channelSubscription?.some((channel) => user?.sub_id === channel?.subscription_id));
  };

  const checkSubscriptionDetails = async () => {

    const channelId = appInfo?.projectDetails?.projectConfig?.config?.FAST_CHANNEL_ID;
    let id = null;
    let type = null;

    if (eventId) {
      id = eventId;
      type = "event";
    } else if (channelId) {
      id = channelId;
      type = "channel";
    } else if (liveDetails?.now_playing) {
      if (liveDetails.now_playing.video_id) {
        id = liveDetails.now_playing.video_id;
        type = "video";
      } else if (liveDetails.now_playing.show_id) {
        id = liveDetails.now_playing.show_id;
        type = "show";
      } else if (liveDetails.now_playing.event_id) {
        id = liveDetails.now_playing.event_id;
        type = "event";
      } else if (liveDetails.now_playing.channel_id) {
        id = liveDetails.now_playing.channel_id;
        type = "channel";
      }
    }

    const channelSubscriptionResponse = await getVideoSubscription(appInfo, id, type);

    if (channelSubscriptionResponse?.status == 200) {

      if (channelSubscriptionResponse?.data?.data.length > 0) {

        if (!user) {

          if (projectInfo?.projectConfig?.config?.WEBSITE_NEW_CHECKOUT_REQUIRED == 'true') {
            navigate("/checkout", { state: { channelId } });
          } else {
            navigate("/login", { state: { ...location.state, path: location?.pathname, channelId } });
          }
        } else {
          const userSubscriptionResponse = await getUserSubscription(appInfo);

          if (userSubscriptionResponse?.status == 200) {

            if (userSubscriptionResponse?.data?.data.length > 0) {

              const subscriptionStatus = await subscriptionCheck(userSubscriptionResponse?.data?.data, channelSubscriptionResponse?.data?.data);

              if (subscriptionStatus === true) {

                startLivePlayer()
              } else {
                redirectToSubscription(channelId)
              }
            } else {
              redirectToSubscription(channelId)
            }

          } else {
            toast.error(<Translate textKey={'wrong_try_again_msg'}/>);
          }

        }
      } else {
        startLivePlayer()
      }

    } else {
      toast.error(<Translate textKey={'wrong_try_again_msg'}/>);
    }

  };

  const redirectToSubscription = (channelId) => {
    if (projectInfo?.projectConfig?.config?.WEBSITE_NEW_CHECKOUT_REQUIRED == 'true') {
      localStorage.setItem("channelId", channelId);
      localStorage.setItem("vanityUrl", '/live');
      navigate("/checkout", { state: { channelId } });
    } else {
      navigate("/subscription", { state: { channelId } });
    }
  }

  const startLivePlayer = async () => {
    const videoJsOptions = {
      autoplay: !kids,
      controls: true,
      responsive: true,
      fluid: true,
      bigPlayButton: !kids,
      poster: liveDetails?.now_playing?.thumbnail_350_200,
      controlBar: {
        pictureInPictureToggle: false,
      },
      sources: [
        {
          src: liveDetails.live_url,
          type: "application/x-mpegURL",
        },
      ],
      // poster:require("../../../images/thumb.png")
    };
    setLivePlayer(<VideoJS kids={kids} onReady={handlePlayerReady} options={videoJsOptions} liveData={liveDetails} is_live={true} watermark={liveDetails?.watermark} />)
  }

  const handlePlayerReady = (player) => {
    playerRef.current = player;
    player.on("play", () => {
      setIsLivePlaying(true);
      let event = videoStarted == true ? "POP09" : "POP02";
      videoStarted = true;
      updateLiveAnalytics(
        eventId ? liveDetails : liveDetails?.now_playing,
        event,
        player.currentTime()
      );
    });

    player.on("timeupdate", function (e) {
      let event = "POP03";

      var hasPlayedTime = player.currentTime();
      var intPlayedTime = parseInt(hasPlayedTime, 10);
      var isSixty = intPlayedTime % seconds === 0 && intPlayedTime !== 0;
      if (isSixty && debounce) {
        debounce = false;
        prevTime = intPlayedTime;
        updateLiveAnalytics(
          eventId ? liveDetails : liveDetails?.now_playing,
          event,
          player.currentTime()
        );
      } else {
        if (debounce == false && prevTime != intPlayedTime) {
          debounce = true;
        }
      }
    });

    player.on("pause", () => {
      setIsLivePlaying(false);
      let event = "POP04";
      updateLiveAnalytics(
        eventId ? liveDetails : liveDetails?.now_playing,
        event,
        player.currentTime()
      );
    });
    player.on("ended", () => {
      let event = "POP05";
      updateLiveAnalytics(
        eventId ? liveDetails : liveDetails?.now_playing,
        event,
        player.currentTime()
      );
    });


    player.on("dispose", () => {
      videoStarted = false;
      setIsLivePlaying(false);
      // player.pause();
    });
    if (kids && liveInitialOverlay) {
      try {
        player.pause();
      } catch (err) {}
    }
  };

  const handleLivePlayPause = () => {
    if (liveInitialOverlay) {
      setLiveInitialOverlay(false);
      playerRef.current?.play();
    } else if (playerRef.current) {
      if (isLivePlaying) {
        playerRef.current.pause();
      } else {
        playerRef.current.play();
      }
    }
  };

  const updateLiveAnalytics = async (nowPlaying, event, time) => {
    const isLive = "1";
    const updateResponse = await onVideoPlayFunction(
      appInfo,
      liveDetailsRef?.current,
      event,
      time,
      isLive
    );
  };

  const fetchLiveInfo = async () => {
    try {
      const response = await getLiveInfo(appInfo);
      setLiveDetails(response?.data?.data[0])
      setLoading(false)
    } catch (err) {
      setLoading(false)
    }
  }
  const fetchEventInfo = async () => {
    try {
      const response = await getEventInfo(appInfo, eventId);
      setLiveDetails(response?.data?.data)
      setLoading(false)
    } catch (err) {
      setLoading(false)
    }
  }

  const fetchFeaturedData = async () => {
    try {
      const response = await fetchApiDataV2(appInfo, 'category/featured')
      const payload = response?.data?.data ?? response?.data
      if (payload?.shows?.length > 0) {
        setFeaturedData(payload)
      }
    } catch (err) {
    }
  }

  const fetchScheduleData = async (upNextStartTime) => {
    try {
      const response = await getLiveSchedule(appInfo)
      if (response?.status === 200) {
        const schedules = response?.data?.data || []
        const cutoff = upNextStartTime ? new Date(upNextStartTime) : new Date()
        const upcomingSchedules = schedules
          .filter(item => new Date(item?.starttime) > cutoff)
          .sort((a, b) => new Date(a.starttime) - new Date(b.starttime))
        setScheduleData(upcomingSchedules)
      }
    } catch (err) {
    }
  }

  if (loading) {
    return (
      <Loading />
    )
  }

  const showLiveChat = eventId && projectInfo?.projectConfig?.config?.COMMENTS_REQUIRED === 'true';

  if (kids) {
    return (
      <div className="livePlayer kidsLive">
        <div className="kidsLiveLayout">
          <div className="kidsLiveLeft">
            <div className="kidsOnNow">
              <div className="onNowMain">
                <div className="onNowPlayerWrap">
                  {livePlayer}
                  {liveInitialOverlay && (
                    <div
                      className="kidsLivePosterOverlay"
                      onClick={handleLivePlayPause}
                      role="button"
                      tabIndex={0}
                      aria-label={t('watch_live')}
                      onKeyDown={e => { if (e.key === 'Enter' || e.key === ' ') handleLivePlayPause(); }}
                    >
                      <img
                        src={liveDetails?.now_playing?.thumbnail_350_200 || projectInfo?.projectConfig?.config?.PLACEHOLDER_IMAGE}
                        alt={liveDetails?.now_playing?.video_title || liveDetails?.title}
                      />
                      <div className="kidsLivePlayOverlay" aria-hidden="true">
                        <div className="playIconContainer">
                          <PlayIcon />
                        </div>
                      </div>
                    </div>
                  )}
                </div>
                {!eventId && (
                  <div className="onNowInfo">
                    <div className="onNowBadge">
                      <span className="onNowDot" aria-hidden="true"></span>
                      <span className="onNowLabelText"><Translate textKey={'on_now'} /></span>
                      {liveDetails?.now_playing?.starttime && (
                        <span className="onNowTime">
                          &ndash; {convertTimeToLocal(liveDetails.now_playing.starttime)}
                        </span>
                      )}
                    </div>
                    <h1 className="onNowTitle">
                      {liveDetails?.now_playing?.video_title || liveDetails?.title}
                    </h1>
                    <p className="onNowDesc">
                      {liveDetails?.now_playing?.video_description}
                    </p>
                    <button
                      className="watchLiveBtn"
                      onClick={handleLivePlayPause}
                      aria-label={isLivePlaying ? t('pause') : t('watch_live')}
                    >
                      <Translate textKey={isLivePlaying ? 'pause' : 'watch_live'} />
                      {!isLivePlaying && <span className="watchLiveArrow">&#9654;</span>}
                    </button>
                  </div>
                )}
              </div>
            </div>

            {!eventId && liveDetails?.up_next && liveDetails.up_next.video_title && (
              <div className="kidsUpNextBar">
                <div className="upNextBarMeta">
                  <span className="upNextLabel"><Translate textKey={'up_next'} /></span>
                  <span className="upNextTime">
                    {convertTimeToLocal(liveDetails.up_next.starttime)}
                  </span>
                </div>
                {(liveDetails.up_next.thumbnail || liveDetails.up_next.thumbnail_350_200) && (
                  <div className="upNextThumb">
                    <img
                      src={liveDetails.up_next.thumbnail_350_200 || liveDetails.up_next.thumbnail}
                      alt={liveDetails.up_next.video_title}
                    />
                  </div>
                )}
                <div className="upNextBarInfo">
                  <h3 className="upNextTitle">{liveDetails.up_next.video_title}</h3>
                  <p className="upNextDesc">{liveDetails.up_next.video_description}</p>
                </div>
              </div>
            )}

            {!eventId && (
              <>
                <div
                  className="kidsComingUpBar"
                  onClick={() => setScheduleExpanded(p => !p)}
                  role="button"
                  tabIndex={0}
                  aria-expanded={scheduleExpanded}
                  onKeyDown={e => {
                    if (e.key === 'Enter' || e.key === ' ') setScheduleExpanded(p => !p);
                  }}
                >
                  <span><Translate textKey={'coming_up'} /></span>
                  <span className="schedTapHint">{!scheduleExpanded && <Translate textKey={'tap_for_more'} />}</span>
                  <span className={`schedChevron${scheduleExpanded ? ' open' : ''}`} aria-hidden="true">&#9660;</span>
                </div>
                {scheduleData.length > 0 && (
                  <div className={`kidsScheduleList${scheduleExpanded ? ' expanded' : ''}`} aria-label="Upcoming schedule">
                    {scheduleData.map((item, idx) => (
                      <div className="kidsScheduleItem" key={item?.id || idx}>
                        <span className="schedTime">
                          {convertTimeToLocal(item.starttime)}
                        </span>
                        {item.thumbnail_350_200 && (
                          <div className="schedThumb">
                            <img
                              src={item.thumbnail_350_200}
                              alt={item.video_title}
                            />
                          </div>
                        )}
                        <div className="schedInfo">
                          <h4 className="schedTitle">{item.video_title}</h4>
                          <p className="schedDesc">{item.video_description}</p>
                        </div>
                      </div>
                    ))}
                  </div>
                )}
              </>
            )}
          </div>

          {featuredData?.shows?.length > 0 && (
            <div className="kidsLiveSidebar" aria-label="Featured shows">
              <h2 className="liveSidebarHeading">{projectInfo?.projectConfig?.pubid === 50174 ? "Featured on GOD TV Kids" : (featuredData.category_name || featuredData.title)}</h2>
              <div className="liveSidebarList">
                {featuredData.shows.map((show, idx) => (
                  <div className="liveSidebarCardItem" key={show.show_id || idx}>
                    <ShowCard data={show} thumbnailOrientation="LANDSCAPE" />
                  </div>
                ))}
              </div>
            </div>
          )}
        </div>
      </div>
    );
  }

  return (
    <div className="livePlayer">
      <div className={`wrapper${showLiveChat ? ' withChat' : ''}`}>
        <div className={`videoContainer${showLiveChat ? ' withChat' : ''}`}>
          <>
           
            {livePlayer}
          </>
          {
            !eventId &&
            <div className="bottom">
              <div className="details">
                <div className="left">
                  <h1 className="heading">{translateText(languageModal, t, 'now_playing')}</h1>
                  <h1 className="title">
                    {liveDetails?.now_playing?.video_title}
                  </h1>
                  <span className="time">
                    {convertTimeToLocal(liveDetails?.now_playing?.start_time)
                      .toString()
                      .toLowerCase()}
                  </span>
                  <p className="description">
                    {liveDetails?.now_playing?.video_description}
                  </p>
                </div>
                <div className="right">
                  <h1 className="heading">{translateText(languageModal, t, 'up_next')}</h1>
                  <h1 className="title">{liveDetails?.up_next?.video_title}</h1>
                  <span className="time">
                    {convertTimeToLocal(liveDetails?.up_next?.start_time)
                      // .toString()
                      // .toLowerCase()
                    }

                  </span>

                  <p className="description">
                    {liveDetails?.up_next?.video_description}
                  </p>
                </div>
              </div>
            </div>
          }
        </div>
        {/* {eventId && projectInfo?.projectConfig?.config?.COMMENTS_REQUIRED === "true" &&
            <div className="wrapper">
               <Comment videoId={eventId} projectInfo={projectInfo} />
            </div>
         } */}
        {showLiveChat && (
          <div className="liveChatContainer">
            <LiveChat
              videoId={eventId}
              projectInfo={projectInfo}
            />
          </div>
        )}
      </div>
    </div>
  )
}

export default LivePlayer
